import type { CreditCardsType } from '@libs/core';

export const getCreditCardIcon = (cardType: CreditCardsType) => {
    if (cardType === 'mc') {
        return 'cc-mastercard';
    }

    return `cc-${cardType.toLowerCase()}`;
};
